var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-row", {
    staticClass: "input_bar_select_root",
    attrs: {
      type: "flex",
      align: "middle"
    }
  }, [_c("a-slider", {
    staticStyle: {
      flex: "5"
    },
    attrs: {
      value: _vm.value,
      min: _vm.min,
      max: _vm.max
    },
    on: {
      change: function change(val) {
        return _vm.$emit("input", val);
      }
    }
  }), _c("SwiperHeightField", {
    staticStyle: {
      flex: "1"
    },
    attrs: {
      max: _vm.max,
      min: _vm.min,
      value: _vm.value,
      options: _vm.options
    },
    on: {
      input: function input(val) {
        return _vm.$emit("input", val);
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };